module.exports = __webpack_public_path__ + "static/img_0-6245484d269f77813b28c40f36c1984c.png";